import {Column} from 'react-table'
import {PaymentHistoryActionsCell} from './PaymentHistoryActionsCell'
import {PaymentHistoryCustomHeader} from './PaymentHistoryCustomHeader'
import {PaymentHistory} from '../../core/_models'
import {PaymentHistoryOwner} from './PaymentHistoryOwner'
import {PaymentHistoryObservation} from './PaymentHistoryObservation'
import {PaymentHistoryContract} from './PaymentHistoryContract'
import {PaymentHistoryRefMonth} from './PaymentHistoryRefMonth'
import {PaymentHistoryDatePay} from './PaymentHistoryDatePay'
import {PaymentHistoryStatus} from './PaymentHistoryStatus'
import {PaymentHistoryValue} from './PaymentHistoryValue'

const PaymentHistoryColumns: ReadonlyArray<Column<PaymentHistory>> = [
  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <PaymentHistoryCustomHeader
        tableProps={props}
        title='CONTRACTS.TITLE_SINGLE'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'contract',
    Cell: ({...props}) => <PaymentHistoryContract PaymentHistory={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ENTREPRENEUR
  {
    Header: (props) => (
      <PaymentHistoryCustomHeader
        tableProps={props}
        title='OWNER.TITLE'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'owner',
    Cell: ({...props}) => <PaymentHistoryOwner PaymentHistory={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ENTERPRISES
  {
    Header: (props) => (
      <PaymentHistoryCustomHeader
        tableProps={props}
        title='PAYMENT_HISTORY.DATE'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'date_reference',
    Cell: ({...props}) => <PaymentHistoryRefMonth PaymentHistory={props.data[props.row.index]} />,
  },
  //HEADER COLUMN - expiration_date ***
  {
    Header: (props) => (
      <PaymentHistoryCustomHeader
        tableProps={props}
        title='PAYMENT_HISTORY.DATE_PAY'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'date_pay',
    Cell: ({...props}) => <PaymentHistoryDatePay PaymentHistory={props.data[props.row.index]} />,
  },
  //HEADER COLUMN - ENTERPRISES TYPE
  {
    Header: (props) => (
      <PaymentHistoryCustomHeader
        tableProps={props}
        title='COMMON.VALUE'
        //title='Carácter'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'value',
    Cell: ({...props}) => <PaymentHistoryValue PaymentHistory={props.data[props.row.index]} />,
  },
  //HEADER COLUMN - ENTERPRISES TYPE
  {
    Header: (props) => (
      <PaymentHistoryCustomHeader
        tableProps={props}
        title='CONDITIONINGS.OBSERVATION'
        //title='Carácter'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'observation',
    Cell: ({...props}) => (
      <PaymentHistoryObservation PaymentHistory={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN -  Status ***
  {
    Header: (props) => (
      <PaymentHistoryCustomHeader
        tableProps={props}
        title='COMMON.STATUS'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'status',
    Cell: ({...props}) => <PaymentHistoryStatus PaymentHistory={props.data[props.row.index]} />,
  },
  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <PaymentHistoryCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <PaymentHistoryActionsCell PaymentHistory={props.data[props.row.index]} />
    ),
  },
]

export {PaymentHistoryColumns}
